import {Link, useParams} from "react-router-dom";
import {useAddTicket, useTicket} from "../../../hooks/useTicket";
import Loader from "../../components/shared/Loader";
import {getTicketStatusColor, ticketStatusOptions} from "../../../utils/status";
import {Field, Formik} from "formik";
import {useSelector} from "react-redux";
import ImageComponent from "../../components/shared/ImageComponent";
import profileImage from "../../../images/profileImage.png";
import noImage from "../../../images/NoImage.jpg";
import fileImage from "../../../images/fileImage.png";
import playButt from "../../../images/thumbVideo.png";
import {buildImageUrl, buildChatImageUrl} from "../../../utils/imageUrlBuilder";
import {
  fileFormat,
  MAX_FILE_SIZE,
  MAX_VIDEO_SIZE,
  ticketStatus,
  userRoleList,
} from "../../../utils/constants";
import {interventionDate} from "../../../utils/date";
import LightGallery from "lightgallery/react";
import {useEffect, useRef, useState} from "react";
import {showToastModal} from "../../components/shared/ToastModalSwal";
import SendMessageIcon from "../../../images/icons/SendMessage";
import {formatFileName} from "../../../utils/file";
import helpClicLogo from "../../../images/mini-logo.png";
import BgPattern from "../../../images/BG-Pattern.png";
import StarIcon from "../../../images/icons/starIcon";
import ProfileCompletion from "../../components/Profile/ProfileCompletion";
import QueryErrorState from "../../components/shared/QueryErrorState";

const TicketPage = () => {
  const {data, isLoading, isError, error, refetch} = useTicket();
  const [progress, setProgress] = useState(0);

  const user = useSelector((state) => state.auth.auth);
  const {onAddMessage, isSendingMessage} = useAddTicket();
  const [fileMessage, setFileMessage] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const handleKeyDownOutside = (event) => {
      if (event.key === "Enter") {
        submitRef.current.click();
      }
    };
    window.addEventListener("keydown", handleKeyDownOutside);

    return () => {
      window.removeEventListener("keydown", handleKeyDownOutside); // cleanup
    };
  }, []);

  const handelScroll = () => {
    const div = chatRef.current;
    if (div) {
      div.scrollTop = div.scrollHeight;
    }
  };

  useEffect(() => {
    if (user?.selectedRole === userRoleList.TECHNICIAN) {
      setProgress(getProgressPercentage(user));
    }
  }, [user]);

  useEffect(() => {
    if (!isLoading) {
      handelScroll();
    }
  }, [data, isLoading]);
  const getProgressPercentage = (data) => {
    if (!data) return 0;

    const checks = [
      !!data?.phone?.length,
      // !!data?.Technician?.taxRegistrationNumber,
      // !!data?.Technician?.companyName?.length,
      !!data?.Technician?.bio?.length,
      !!data?.address?.length,
      !!data?.Technician?.FileUploads?.length,
      !!data?.Technician?.InterventionAreas?.length,
      !!data?.Technician?.SubCategories?.length,
      !!data?.Technician?.BankAccounts?.length,
    ];

    const completed = checks.filter(Boolean).length; // Count all truthy values
    const total = checks.length;

    return (completed / total) * 100;
  };

  const chatRef = useRef(null);
  const submitRef = useRef(null);
  const handleImage = (e) => {
    const file = e.target.files[0];
    const input = e.target;
    // Get the selected file
    if (!file) return;

    const validTypes = ["image/", "video/", "application/"];

    // Check if file type starts with "image/" or "video/"
    if (!validTypes.some((type) => file.type.startsWith(type))) {
      showToastModal({
        success: false,
        title: "Erreur d'importation",
        message: "Veuillez importer uniquement des images ou des vidéos.",
        buttonTitle: "Ressayer",
      });
      input.value = ""; // Clear the input value
      return;
    }

    // Check file size based on file type
    if (file.type.includes("video") && file.size > MAX_VIDEO_SIZE) {
      // setError("La taille maximale des vidéos est de 50MB.");
      showToastModal({
        success: false,
        title: "Erreur d'importation",
        message: "La taille maximale des vidéos est de 20MB.",
        buttonTitle: "Ressayer",
      });
      input.value = ""; // Clear the input value

      return;
    } else if (file.size > MAX_FILE_SIZE && !file.type.includes("video")) {
      // setError("La taille maximale des fichiers est de 10MB.");
      showToastModal({
        success: false,
        title: "Erreur d'importation",
        message: "La taille maximale des fichiers est de 5MB.",
        buttonTitle: "Ressayer",
      });
      input.value = ""; // Clear the input value

      return;
    }
    const imageUrl = URL.createObjectURL(file);
    if (file) {
      file.imageUri = imageUrl;
      setFileMessage(file);
      input.value = ""; // Clear the input value
    }
  };

  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }

  return (
    <div className="w-full  lg:grid lg:grid-cols-8 gap-6 ">
      <div className="w-full col-span-2 h-fit bg-white rounded-2xl hidden lg:block sticky top-[90px]  ">
        <div
          className="w-full h-[84px] bg-cover bg-center rounded-t-xl relative "
          style={{backgroundImage: `url('${BgPattern}')`}}
        >
          <div className="absolute -bottom-12 rounded-md left-[50%] -translate-x-[50%]">
            <div className="relative">
              {!!user?.avgRating && (
                <Link
                  to={"/mon-profil/#avis"}
                  className="bg-[#FFC107] w-1/2 flex justify-center gap-[2px] items-center leading-none p-[1px] text-white text-[12px] absolute bottom-0 rounded-md left-[50%] -translate-x-[50%] "
                >
                  {Number(user?.avgRating).toFixed(2)}
                  <StarIcon className="fill-white stroke-none w-3 h-3" />
                </Link>
              )}
              {/* <div className="absolute w-6 h-6 bg-white flex justify-center items-center top-1 right-1 text-[#1A64B9] rounded-full">
                  <img className="w-4" src={Crown} alt="" title="Professionnel" />{" "}
                </div> */}
              <ImageComponent
                src={buildImageUrl(user?.imageUri)}
                alt=""
                className=" w-[104px] h-[104px] rounded-full object-cover ring-4 ring-white"
                fallback={
                  <img
                    src={profileImage}
                    alt=""
                    className=" w-[104px] h-[104px] rounded-full object-cover ring-4 ring-white"
                    width="130"
                  />
                }
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-start items-center mt-14">
          <Link
            to={"/mon-profil"}
            className="text-center text-[#19295C] font-semibold capitalize "
          >
            {`${user.lastName}  ${user.firstName}`}
          </Link>
          <div className="text-center text-primary font-normal text-sm">
            {user.selectedRole === userRoleList.TECHNICIAN
              ? "Prestataire"
              : "Client"}
          </div>
          <Link
            to={"/mon-profil#avis"}
            className="text-right lg:text-center flex-grow  lg:flex-grow-0 text-xs font-normal lg:mt-3  underline text-[#7E7E7E] "
          >
            {user?.reviews?.length ?? 0} évaluation(s)
          </Link>

          {user.selectedRole === userRoleList.TECHNICIAN ? (
            <>
              {" "}
              <div className="text-xs font-medium text-center text-[#9B9B9B] px-[26px] mt-3 line-clamp-5">
                {data?.Technician?.bio ?? ""}
              </div>
              <Link
                to="/mon-profil"
                className="w-full px-3 py-4 flex justify-center items-center border-b border-solid border-[#D6E2EF] cursor-pointer "
              >
                {progress !== 100 && (
                  <ProfileCompletion
                    progress={progress.toFixed(0)}
                    onCompleteProfile={() => {}}
                  />
                )}
              </Link>
              <Link
                to={"/tableau-de-bord"}
                className="w-full flex justify-start gap-[12px] items-center cursor-pointer text-2xl text-[#6B6B6B] border-b border-solid group hover:text-[#FF6600] border-[#D6E2EF] px-4 py-3 "
              >
                <i className="fi fi-rr-dashboard-panel flex justify-center items-center group-hover:text-[#FF6600]"></i>
                <span className="font-semibold text-[15px] text-[#9B9B9B] group-hover:text-[#FF6600] ">
                  Tableau de bord
                </span>
              </Link>
            </>
          ) : (
            <Link
              to="/deposer-une-annonce"
              className="w-full flex justify-start gap-[12px] items-center cursor-pointer text-xl text-[#6B6B6B] border-t border-b border-solid border-[#D6E2EF] px-4 py-3 group hover:text-[#FF6600] mt-3 "
            >
              <i className="fi fi-rr-multiple flex items-center"></i>
              <span className="font-semibold text-[14px] text-[#9B9B9B] group-hover:text-[#FF6600] ">
                Créer une annonce
              </span>
            </Link>
          )}

          <Link
            to={"/mon-profil"}
            className="w-full flex justify-start gap-[12px] items-center cursor-pointer text-xl text-[#6B6B6B] group hover:text-[#FF6600] px-4 py-3 "
          >
            <i className="fi fi-rr-user flex justify-center items-center group-hover:text-[#FF6600]"></i>
            <span className="font-semibold text-[14px] text-[#9B9B9B] group-hover:text-[#FF6600]  ">
              Mon profil
            </span>
          </Link>
        </div>
      </div>
      <div className="w-full col-span-6 flex flex-col  px-4 lg:!px-0 justify-start items-center gap-5 text-[#19295C] ">
        <div className="w-full bg-white !rounded-xl flex flex-col gap-1 justify-start items-center  overflow-hidden">
          <div className="flex w-full gap-2 bg-[#1A64B9] rounded-t-lg  ">
            <div className="flex items-center min-w-fit justify-start gap-2 border-r border-[#FFF2EA] p-3 ">
              <img
                className="w-16 aspect-square rounded-full hidden sm:block"
                alt="profileImg"
                src={helpClicLogo}
              />
              <div className="justify-center text-white font-semibold lg:font-bold text-sm lg:text-base items-start flex flex-col gap-1">
                {!!data?.User ? (
                  <>
                    <span className="capitalize">
                      {data?.User?.lastName} {data?.User?.firstName}
                    </span>
                    <span className="text-xs sm:text-sm text-[#FF6600] font-normal">
                      {data?.User?.selectedRole === userRoleList.ADMIN
                        ? "Administrateur"
                        : "Modérateur"}
                    </span>{" "}
                  </>
                ) : (
                  <>
                    <span className="">Équipe support </span>
                    <span className="text-sm text-[#FF6600] font-normal">
                      Administrateur
                    </span>{" "}
                  </>
                )}
              </div>
            </div>
            <div className=" flex flex-grow flex-wrap  items-center gap-2 font-semibold text-xs lg:text-base   p-3 text-white">
              <span className=" flex-grow line-clamp-2  capitalize-first ">
                {data.title}
              </span>
              <div
                className="w-fit h-fit   text-sm rounded-full capitalize flex justify-between !px-4 !py-[6px]"
                style={{
                  backgroundColor: getTicketStatusColor({
                    status: data?.status,
                  }).bg,
                  color: getTicketStatusColor({status: data?.status}).color,
                }}
              >
                <span className="font-medium">
                  {
                    ticketStatusOptions.find(
                      (tick) => tick.value === data?.status,
                    ).label
                  }
                </span>
              </div>
            </div>
          </div>
          <div
            ref={chatRef}
            className="w-full h-[60vh] flex flex-col gap-1 !p-3 overflow-y-scroll overflow-style-none"
          >
            {!data?.TicketMessages.length ? (
              <div className="w-full text-center">pas de messages</div>
            ) : (
              // data?.TicketMessages?.map((message) => (
              //   <div className={`w-full flex `}>

              //   </div>
              // ))

              data?.TicketMessages?.map((message) => (
                <div
                  key={message.id}
                  className={`flex gap-3 items-start w-full justify-start ${
                    message.userId !== user.id ? "" : "flex-row-reverse"
                  }`}
                >
                  <ImageComponent
                    alt=""
                    src={
                      ["ADMIN", "SUPPORT"].includes(message?.User?.selectedRole)
                        ? helpClicLogo
                        : buildImageUrl(message?.User?.imageUri)
                    }
                    className="w-8 aspect-square rounded-full object-cover"
                    fallback={
                      <img
                        alt=""
                        className="w-8 aspect-square rounded-full object-cover"
                        src={profileImage}
                      />
                    }
                  />

                  <div
                    className={`mt-4 p-3 font-medium flex flex-col gap-2 text-left text-[15px] leading-6 text-[#2F2F2F] max-w-[400px] ${
                      message.userId !== user.id
                        ? "bg-[#FFF2EA] rounded-tr-xl rounded-b-xl"
                        : "bg-[#F4F4F4] rounded-tl-xl rounded-b-xl"
                    }`}
                  >
                    {!!message?.FileUploads?.length &&
                      message?.FileUploads[0].format &&
                      (message.FileUploads[0].format === fileFormat.PDF ? (
                        <div className="flex items-center gap-2 p-2 bg-gray-100 rounded ">
                          <i className="fi fi-sr-document"></i>{" "}
                          <span className="truncate">
                            {message.FileUploads[0].path || "File"}
                          </span>
                          <a
                            href={buildImageUrl(message.FileUploads[0].path)}
                            download={message.FileUploads[0].path
                              .split("/")
                              .pop()} // Extracts the filename
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#1A64B9] cursor-pointer"
                          >
                            <i className="fi fi-sr-down-to-line"></i>
                          </a>
                        </div>
                      ) : message.FileUploads[0].format === fileFormat.VIDEO ? (
                        <video
                          onLoadedData={() => handelScroll()}
                          className="w-[90%] aspect-video "
                          src={buildImageUrl(message.FileUploads[0].path)}
                          alt=""
                          autoPlay={false}
                          controls={true}
                        />
                      ) : (
                        <LightGallery>
                          <ImageComponent
                            onLoad={() => handelScroll()}
                            className="w-[90%] aspect-square object-cover"
                            src={buildImageUrl(message.FileUploads[0].path)}
                            alt=""
                            fallback={
                              <img
                                className="w-[90%] aspect-square object-cover "
                                src={noImage}
                                alt=""
                                autoPlay={false}
                              />
                            }
                          />
                        </LightGallery>
                      ))}
                    <div className="w-full">{message.message}</div>
                    <div className="w-full text-[10px] text-[#7e7e7e]">
                      {interventionDate(message.createdAt)}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          {[ticketStatus.INITIATED, ticketStatus.PROCESSING].includes(
            data?.status,
          ) && (
            <div className="w-full">
              <Formik
                initialValues={{message: ""}}
                onSubmit={async (values, {setFieldValue, setSubmitting}) => {
                  if (!values.message && !fileMessage) {
                    return;
                  }
                  const body = {};
                  if (!!values.message) {
                    body.message = values.message;
                  }
                  if (!!fileMessage) {
                    body.file = fileMessage;
                  }
                  try {
                    await onAddMessage({ticketID: data?.id, body});
                    setFieldValue("message", "");
                    setFileMessage(null);
                  } finally {
                    setSubmitting(false);
                  }
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleSubmit,
                  setFieldValue,
                  handleChange,
                  isSubmitting,
                }) => (
                  <form
                    onSubmit={handleSubmit}
                    className="w-full flex flex-col gap-1"
                  >
                    <div className="sm:!p-4  !p-2 flex items-center gap-3 bg-[#F1F2F7] sm:mx-3 rounded-t-2xl">
                      <span className="text-base">
                        <i
                          class="fi fi-rr-clip flex items-center cursor-pointer"
                          onClick={() => {
                            inputRef.current.click();
                          }}
                        ></i>
                      </span>
                      <div
                        className={`flex flex-grow   bg-white  rounded-xl !py-2 !px-1 sm:!py-3.5 sm:!px-4 items-center`}
                      >
                        {fileMessage && (
                          <div className="flex items-center gap-2 justify-start mr-2 ">
                            <div className="ml-3 relative text-lg text-red-600">
                              <div className="bg-red-600 rounded-full w-5 h-5 flex absolute -top-2 -right-2 justify-center items-center text-white cursor-pointer">
                                <i
                                  class="fi fi-rr-cross-small flex items-center"
                                  onClick={() => setFileMessage(null)}
                                ></i>
                              </div>
                              {fileMessage.type.includes("video") ? (
                                <img
                                  src={playButt}
                                  alt="Preview"
                                  className="h-10  object-cover rounded-md"
                                />
                              ) : fileMessage?.type.includes("application") ? (
                                <img
                                  src={fileImage}
                                  alt="Preview"
                                  className="h-10 aspect-square object-cover rounded-md"
                                />
                              ) : (
                                <img
                                  src={fileMessage.imageUri}
                                  alt="Preview"
                                  className="h-10 aspect-square object-cover rounded-md"
                                />
                              )}
                            </div>
                            <span
                              className="text-[10px] text-[#7e7e7e] truncate"
                              title={fileMessage?.name}
                            >
                              {formatFileName(fileMessage?.name)}
                            </span>
                          </div>
                        )}
                        <input
                          type="file"
                          className="hidden"
                          multiple={false}
                          disabled={isSubmitting || isSendingMessage}
                          ref={inputRef}
                          onChange={handleImage}
                          accept="image/*, video/mp4, application/*"
                        />
                        <input
                          type="text"
                          value={values.message}
                          onChange={handleChange}
                          name="message"
                          disabled={isSubmitting || isSendingMessage}
                          // value={message.text}
                          // disabled={!!blocked}
                          // onChange={(e) =>
                          //   setMessage((prev) => ({...prev, text: e.target.value}))
                          // }
                          placeholder="Écrivez un message..."
                          className={`flex-grow   border-none `}
                          // onKeyDown={handleKeyDown}
                        />
                        <button
                          type="submit"
                          ref={submitRef}
                          disabled={isSubmitting || isSendingMessage}
                        >
                          <SendMessageIcon
                            className={"fill-blue-600 w-6 h-6 cursor-pointer"}
                            // onClick={() => handleSend()}
                          />
                        </button>
                      </div>
                    </div>
                    {/* <div className="form-group !mb-1 ">
                    <Field
                      as="textarea"
                      rows={3}
                      className="form-control placeholder:text-sm"
                      name="message"
                      placeholder="Votre message ici..."
                    />
                  </div>
                  <div className="flex w-full items-center justify-start gap-2 text-xl flex-wrap ">
                    <button
                      type="submit"
                      className="text-white w-14 aspect-square p-3 bg-[#1A64B9] !rounded-md"
                    >
                      <i className="fi fi-rr-paper-plane flex items-center"></i>
                    </button>
                    <button
                      onClick={() => {
                        inputRef.current.click();
                      }}
                      type="button"
                      className="bg-white w-14 aspect-square !text-[#0D44B1] !border !border-[#0D44B1] p-3 !rounded-md "
                    >
                      <i className="fi fi-rr-paperclip-vertical flex items-center"></i>
                    </button>
                    <input
                      ref={inputRef}
                      className="hidden"
                      type="file"
                      onChange={handleImage}
                    />
                    {!!fileMessage && (
                      <div className="flex items-center gap-2 flex-nowrap max-w-[80%] ">
                        <div className="   truncate break-all text-xs">
                          {fileMessage.name}
                        </div>
                        <button
                          onClick={() => {
                            setFileMessage(null);
                          }}
                          type="button"
                          className="bg-white  !text-[#FF0000] !border !border-[#FF0000] p-2 !rounded-md "
                        >
                          <i className="fi fi-rr-trash flex items-center"></i>
                        </button>
                      </div>
                    )}
                  </div> */}
                  </form>
                )}
              </Formik>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TicketPage;
